const DEVICES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    MO_APP: 'mo_app'
};

const getDeviceType = () => {
    if (window.location.pathname.includes('mo.v2.html')) {
        return DEVICES.MO_APP;
    }
    return DEVICES.DESKTOP;
};

export { getDeviceType, DEVICES };
